<template>
  <div id="new-stepper">
    <div class="row justify-content-center">
      <div class="stepper-wrapper">
        <ul class="stepper px-6 py-0 mx-0">
          <li
            v-for="(step, index) in steps"
            :key="step.id"
            class="step"
            :class="{
              'active': index + 1 == active
            }"
          >
            <div
              class="step-title font-small"
            >
              <span class="label d-block">{{ step }}</span>
            </div>
          </li>
        </ul>
        <div class="line" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    active: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
#new-stepper {
  // TODO: ステップ3つの固定幅にしているので、個数によって動的に変化
  .stepper-wrapper {
    width: 356px;
    position: relative;
    .line {
      width: calc(100% - 56px);
      height: 1px;
      display: block;
      position: absolute;
      top: 24px;
      right: 28px;
      border-top: 1px solid #b8c2cc;
      z-index: -1;
    }
    .stepper {
      display: flex;
      justify-content: space-between;
      li {
        display: inline-block;
        text-align: center;
        margin-bottom: 0.75rem;
        position: relative;
        color: #b8c2cc;
        &.step {
          width: 1.57rem;
          &:before {
            font-size: 0.928rem;
            width: 1.57rem;
            height: 1.57rem;
            background-color: #b8c2cc;
            left: 0;
            top: 0;
            line-height: normal;
          }
        }
        &.active {
          color: #0080fc;
          &:before {
            background-color: #0080fc;
          }
        }
        .step-title {
          padding: 1.6rem 0 0;
          cursor: text;
          &:hover {
            background-color: inherit;
          }
        }
        &:not(:last-of-type):after {
          display: none;
        }
      }
    }
  }
}
</style>
